<template>
  <article class="pc-news-carousel" @click="$emit('click')">
    <Swiper
      ref="newsSwiper"
      class="news-swiper"
      :options="swiperOptions"
      @slide-change="onSlideChange"
    >
      <SwiperSlide
        v-for="(item, index) in items"
        :key="index"
        class="carousel-slide"
        :class="item.imageClass"
        :style="getSlideStyle(item)"
      />
    </Swiper>
    <div class="featured-caption">
      <h3>{{ getNewsTitle(activeItem) }}</h3>
      <div class="slider-dots">
        <button
          v-for="(item, index) in items"
          :key="index"
          type="button"
          :class="{ active: index === currentIndex }"
          @click.stop="setActive(index)"
        ></button>
      </div>
    </div>
  </article>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'NewsCarousel',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      currentIndex: this.value,
      swiperOptions: {
        autoplay: {
          delay: 4500,
          disableOnInteraction: false,
        },
        loop: true,
        speed: 450,
        slidesPerView: 1,
        watchOverflow: true,
      },
    };
  },
  computed: {
    activeItem() {
      return this.items[this.currentIndex] || this.items[0] || {};
    },
  },
  watch: {
    value(index) {
      if (index !== this.currentIndex) {
        this.currentIndex = index;
        this.syncSwiper();
      }
    },
  },
  mounted() {
    this.syncSwiper();
  },
  methods: {
    getNewsData(item) {
      return item.data || item;
    },
    getNewsTitle(item) {
      const data = this.getNewsData(item);

      return data.customTitle || data.title || '';
    },
    getNewsImageUrl(item) {
      const data = this.getNewsData(item);
      const imageUrl = data.imageUrl;

      if (Array.isArray(imageUrl)) {
        return imageUrl[0] || '';
      }

      return imageUrl || '';
    },
    getSlideStyle(item) {
      const imageUrl = this.getNewsImageUrl(item);

      if (!imageUrl) {
        return {};
      }

      return {
        backgroundImage: `url(${imageUrl})`,
      };
    },
    setActive(index) {
      this.currentIndex = index;
      this.$emit('input', index);
      this.$emit('change', index);
      this.syncSwiper();
    },
    onSlideChange() {
      const swiper = this.getSwiper();
      if (swiper) {
        const index = swiper.realIndex || 0;
        this.currentIndex = index;
        this.$emit('input', index);
        this.$emit('change', index);
      }
    },
    syncSwiper() {
      this.$nextTick(() => {
        const swiper = this.getSwiper();
        if (swiper && swiper.realIndex !== this.currentIndex) {
          swiper.slideToLoop(this.currentIndex);
        }
      });
    },
    getSwiper() {
      const newsSwiper = this.$refs.newsSwiper;
      if (newsSwiper && newsSwiper.swiperInstance) {
        return newsSwiper.swiperInstance;
      }
      return null;
    },
  },
});
</script>

<style lang="less" scoped>
.pc-news-carousel {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-radius: 2px;
  background: #e9eef3;
  cursor: pointer;
}

.news-swiper {
  width: 100%;
  height: 100%;
}

.carousel-slide {
  height: 100%;
  background-repeat: no-repeat;
  background-position: center top;
  background-size: cover;
}

.news-cover-main {
  background-image: url('../assets/pc/pc-banner.png');
}

.news-cover-photo {
  background-image: url('../assets/pc/摄影作品@2x.png');
}

.news-cover-design {
  background-image: url('../assets/pc/视听设计作品1.png');
}

.featured-caption {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2;
  height: 58px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 28px;
  background: rgba(0, 0, 0, 0.58);
  box-sizing: border-box;

  h3 {
    flex: 1;
    min-width: 0;
    margin: 0;
    padding-right: 24px;
    overflow: hidden;
    color: #fff;
    font-size: 16px;
    font-weight: 500;
    line-height: 58px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.slider-dots {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;

  button {
    width: 10px;
    height: 10px;
    display: block;
    padding: 0;
    border: 0;
    border-radius: 50%;
    outline: none;
    background: rgba(255, 255, 255, 0.55);
    cursor: pointer;

    &.active {
      width: 28px;
      height: 8px;
      border-radius: 10px;
      background: #fff;
    }
  }
}
</style>
